// Read more for rich text section
    const spans = document.querySelectorAll('.read-more-btn');
    if (spans) {
        spans.forEach(span => {
          span.addEventListener('click', function() {
            const textElement = this.previousElementSibling;
        
            if (textElement.classList.contains('expanded')) {
              textElement.classList.remove('expanded');
              this.textContent = this.getAttribute('data-read-more');
            } else {
              textElement.classList.add('expanded');
              this.textContent = this.getAttribute('data-read-less');
            }
            
          });
        });
  }